import { ApplicationRef, ComponentRef, Injectable, RendererFactory2, createComponent, inject } from '@angular/core';
import { Subscription, debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { LoadersFacade } from '@app/store/loader';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private applicationRef = inject(ApplicationRef);
    private rendererFactory2 = inject(RendererFactory2);
    private renderer2 = this.rendererFactory2.createRenderer(null, null);
    private loadersFacade = inject(LoadersFacade);
    private componentRef!: ComponentRef<SpinnerComponent>;

    private subscriptions$ = new Subscription();

    constructor() {
        this.subscriptions$.add(
            this.loadersFacade.loading$
                .pipe(
                    debounceTime(50),
                    distinctUntilChanged(),
                    tap((loading) => {
                        if (loading) {
                            this.show();
                        } else {
                            this.hide();
                        }
                    }),
                )
                .subscribe(),
        );
    }

    private show(): void {
        this.componentRef = createComponent(SpinnerComponent, {
            environmentInjector: this.applicationRef.injector,
        });
        this.applicationRef.attachView(this.componentRef.hostView);
        this.renderer2.appendChild(document.querySelector('body'), this.componentRef.location.nativeElement);
    }

    private hide(): void {
        if (this.componentRef) {
            this.applicationRef.detachView(this.componentRef.hostView);
            this.componentRef.destroy();
        }
    }
}
